import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/6b05b700801bb2baaf9555b3a3f6d3f5.jpg"
            alt="About DemoHub"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-7xl font-black text-white mb-6 leading-tight">
            About DemoHub
          </h1>
          <p className="text-xl text-white/90 leading-relaxed">
            Revolutionizing the demolition industry through technology and trust
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-5xl font-black text-gray-900 mb-6 leading-tight">
                Our Mission
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                At DemoHub, we're on a mission to transform the demolition industry by creating a transparent, efficient, and reliable platform that connects property owners with licensed demolition professionals.
              </p>
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                We believe that finding the right demolition contractor shouldn't be complicated or stressful. That's why we've built a comprehensive platform that streamlines the entire process, from initial quote requests to project completion.
              </p>
              <p className="text-gray-600 text-base leading-relaxed">
                Our commitment to quality, safety, and customer satisfaction drives everything we do. We carefully vet all our licensees to ensure they meet the highest industry standards.
              </p>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20demolition%20site%20with%20advanced%20equipment%20excavators%20and%20machinery%20organized%20professional%20demolition%20work%20safety%20protocols%20visible%20clean%20efficient%20workspace%20bright%20daylight%20industrial%20excellence&width=700&height=600&seq=mission1&orientation=portrait"
                alt="Our mission"
                className="w-full h-[600px] object-cover object-top rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-5xl font-black text-gray-900 mb-16 text-center leading-tight">
            Our Core Values
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-10 shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Safety First
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We prioritize safety above all else. Every licensee in our network is fully licensed, insured, and trained in the latest safety protocols to protect workers and property.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-10 shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Transparency
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We believe in complete transparency throughout the demolition process. From upfront pricing to project timelines, you'll always know exactly what to expect.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-10 shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-star-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Excellence
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We're committed to delivering exceptional results on every project. Our rigorous vetting process ensures only the best demolition professionals join our network.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=demolition%20industry%20evolution%20from%20traditional%20to%20modern%20methods%20before%20and%20after%20comparison%20professional%20demolition%20equipment%20technology%20advancement%20construction%20industry%20progress%20organized%20workspace&width=700&height=600&seq=story1&orientation=portrait"
                alt="Our story"
                className="w-full h-[600px] object-cover object-top rounded-2xl shadow-xl"
              />
            </div>

            <div>
              <h2 className="text-5xl font-black text-gray-900 mb-6 leading-tight">
                Our Story
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                DemoHub was founded in 2020 by a team of construction industry veterans who recognized a critical gap in the demolition services market. Property owners struggled to find reliable contractors, while qualified demolition companies had difficulty connecting with potential clients.
              </p>
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                We set out to solve this problem by creating a comprehensive platform that benefits both sides of the equation. Today, DemoHub serves thousands of property owners and connects them with over 150 licensed demolition professionals across the nation.
              </p>
              <p className="text-gray-600 text-base leading-relaxed">
                Our platform has facilitated millions of dollars in demolition projects, helping property owners achieve their goals while supporting the growth of quality demolition businesses.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-24 bg-teal-600">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 text-center">
            <div>
              <div className="text-6xl font-black text-white mb-3">150+</div>
              <div className="text-white/90 text-sm font-medium">Licensed Contractors</div>
            </div>
            <div>
              <div className="text-6xl font-black text-white mb-3">2,500+</div>
              <div className="text-white/90 text-sm font-medium">Projects Completed</div>
            </div>
            <div>
              <div className="text-6xl font-black text-white mb-3">98%</div>
              <div className="text-white/90 text-sm font-medium">Customer Satisfaction</div>
            </div>
            <div>
              <div className="text-6xl font-black text-white mb-3">50+</div>
              <div className="text-white/90 text-sm font-medium">Cities Served</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}